import React, { useState } from 'react';
import cx from 'classnames';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import FilterMenu from '~/cards/components/CardListing/CardListingRedesign/CardListingFilter/FilterMenu/FilterMenu';

import { FilterInfo, ActiveFilters, FilterValue, FilterKey } from '../FilterTypes';
import { FilterChip } from '../FilterStyles.styles';

import styles from './styles.module.less';

const wideFilters = ['MAGNET', 'CUSTOM PHOTO', 'FOIL', 'LETTERPRESS', 'RECEPTION ONLY'];

type FilterButtonsProps = {
  filterInfo: FilterInfo;
  updateFilter: (key: FilterKey, value: FilterValue) => void;
  activeFilters: ActiveFilters;
};

export const FilterButtons: React.FC<FilterButtonsProps> = ({
  filterInfo,
  updateFilter,
  activeFilters,
}) => {
  const {
    content,
    filterStateKey,
    label,
    newBadge,
    optionList,
    numSelected,
    isActive,
    visibility,
    individualVisibilityCheck,
    cardType,
  } = filterInfo;
  const [isOpen, setIsOpen] = useState(false);

  if (!visibility) return null;

  const filterLabel = numSelected() ? `${label} (${numSelected()})` : label;
  const isWideDropdown = wideFilters.includes(label.toUpperCase());

  return (
    <div className={styles.filterBtnContainer}>
      <Dropdown active={isOpen} onShow={() => setIsOpen(true)} onHide={() => setIsOpen(false)}>
        <DropdownTrigger>
          <FilterChip
            withCaret
            selected={isOpen}
            active={isActive}
            className={cx(styles.filterBtnRedesign, {
              [styles.newBadge]: newBadge,
            })}
          >
            {filterLabel}
          </FilterChip>
        </DropdownTrigger>
        <DropdownContent>
          <div
            className={cx(styles.dropdownContainer, {
              [styles.dropdownContainerWide]: isWideDropdown,
            })}
          >
            {isOpen && (
              <FilterMenu
                content={content}
                updateFilter={updateFilter}
                activeFilters={activeFilters}
                optionList={optionList}
                filterStateKey={filterStateKey}
                individualVisibilityCheck={individualVisibilityCheck}
                cardType={cardType}
              />
            )}
          </div>
        </DropdownContent>
      </Dropdown>
    </div>
  );
};
